module.exports = __webpack_public_path__ + "static/img/ndvi3.3e14ecf4.jpg";